import BaseComponent from "./BaseComponent";
import Switch from "./Switch";
export default class KeySwitch extends BaseComponent {
   
    constructor(props) {
        super(props);
        this.text = props.value;
    }

    setConfig(key, value) {
        this.text[key] = value;
        this.updateContext(this.text);
    }

    /**
     * React render
     * @returns {XML|Array}
     */
     //BEN add readOnly
    render() {
       
            const texts = [];
           
             texts.push(
               
                <div className="row">
                    <div className="col-md-4">
                    <label className="form-component label">{this.getPropLabel("billing")}</label>
                    </div>
                    <div className="col-md-4">
                    <Switch context={this.props.context} valKey={"oncePerCall"} disabled={this.props.context.readOnly}  label={"1x per call"}checked={ this.props.context.props.config.oncePerCall?this.props.context.props.config.oncePerCall:false } />
                    </div>
                 
                </div>

            )
    
            return texts;
        }
}
